import styled from 'styled-components';

import { ViewerTopGap } from 'styles/constants';

import Icon from 'components/Icon';
import { themes } from 'styles/themes/wikifactoryNew';

export const FloatingStyled = styled.div`
  display: flex;
  flex-direction: column;
  position: fixed;
  align-items: center;
  left: ${ViewerTopGap}px;
  top: ${ViewerTopGap}px;
  border: 1px solid ${themes.color.wfGrey350};
  min-width: 100px;
  user-select: none;
  background: white;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;
  z-index: 1012;
`;

export const FloatingTitleStyled = styled.div`
  display: grid;
  min-width: 150px;
  width: 100%;
  grid-template-columns: auto 35px;
  position: relative;
  align-items: center;
  padding: 0 0.1rem 0 0.5rem;
  color: ${props => props.theme.color.wfBlack};
  background: ${themes.color.wfGrey200};
  border-bottom: 1px solid
    ${props => (props.expanded ? themes.color.wfGrey350 : 'transparent')};
  cursor: ${props => (props.dragging ? 'grabbing' : 'grab')};
  svg {
    margin: 2px;
  }
  &:hover {
    background: ${props => props.theme.color.wfBlue200};
  }
`;

export const FloatingInnerStyled = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  background-color: ${props => `${props.theme.color.wfWhite}AA`};
`;

export const IconStyled = styled(Icon)`
  margin-right: ${props => props.theme.spacing.small};
  &:hover {
    color: ${props => props.theme.color.primary};
    cursor: pointer;
  }
`;

export const LabelStyled = styled.span`
  padding-right: 20px;
  font-weight: 600;
`;
